import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FlexCenterAligned } from '../../styled/common';
import BinaModal from '../ReactModal';
import ChangeLang from '../MenuList/ChangeLang';
import Icon from '../Icon';
import LanguageIcon from '../../public/static/images/language.svg';
import PhoneIcon from '../../public/static/images/phone_call_black-icon.svg';
import { getIsCurrentPage } from '../../utils/helpers/getIsCurrentPage';
import {
  BuildLink,
  ChangeLanguageButtonContainer,
  ContactUsIcon,
  ContactUsLink,
  ContactUsTitle,
  HeaderMenuColumn,
  HeaderMenuColumnItem,
  HeaderMenuWrapper,
  Label
} from './styled';
import { STATIC_PAGES } from '../../utils/helpers/constants';
import CONFIG from '../../config';

const HeaderModalMenu = ({
  contacts,
  isOpenHeaderMenu,
  setIsOpenHeaderMenu,
  handleModalMenuMouseLeave,
  handleModalMenuMouseEnter
}) => {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const scrollbarWidth = `${window.innerWidth - document.body.clientWidth}px`;
  const { tapAzBuildLink, tel, tel_url: telUrl, email } = contacts;

  const buildLinkComponent = (
    <BuildLink
      key="build"
      data-cy="build"
      href={tapAzBuildLink}
      target="_blank"
    >
      {t('main_menu.build_services')}
    </BuildLink>
  );

  const changeLanguageComponent = (
    <ChangeLanguageButtonContainer key="lan">
      <Icon
        IconComponent={LanguageIcon}
        width={19}
        height={19}
        indent={false}
        color="dark"
      />
      <ChangeLang i18n={i18n} t={t} />
    </ChangeLanguageButtonContainer>
  );

  const contactUsComponent = (
    <div key="con">
      <ContactUsTitle data-cy="header-menu-phone-title">
        {t('common.contact_us')}
      </ContactUsTitle>
      <ContactUsLink
        href={`tel:${telUrl}`}
        role="button"
        tabIndex={0}
        data-cy="header-menu-phone"
        aria-label="Open menu"
      >
        <ContactUsIcon>
          <Icon width={15} height={15} IconComponent={PhoneIcon} indent />
        </ContactUsIcon>
        <span>{tel}</span>
      </ContactUsLink>
      <ContactUsLink
        href={`mailto:${email}`}
        role="button"
        tabIndex={0}
        data-cy="header-menu-email"
        styles={'display: block;margin-top: 3px'}
      >
        <span>{email}</span>
      </ContactUsLink>
    </div>
  );

  const menuListArray = [
    {
      column: [
        {
          title: t('main_menu.residences'),
          cypress: 'residencies',
          path: '/yasayis-kompleksleri'
        },
        {
          title: t('main_menu.agencies'),
          cypress: 'agencies',
          path: '/agentlikler'
        },
        {
          title: 'component',
          component: buildLinkComponent
        }
      ]
    },
    {
      column: [
        {
          cypress: 'about',
          title: t('footer.about'),
          path: STATIC_PAGES.ABOUT,
          route: '/pages/[page]'
        },
        {
          cypress: 'agreement',
          title: t('footer.agreement'),
          path: STATIC_PAGES.TERMS,
          route: '/pages/[page]'
        },
        {
          cypress: 'privacy',
          title: t('footer.privacy'),
          path: STATIC_PAGES.PRIVACY,
          route: '/pages/[page]'
        },
        {
          cypress: 'advertisement',
          title: t('footer.advertise'),
          path: CONFIG.getLandingPageUrl('burger', i18n.language),
          label: t('common.new')
        }
      ]
    },
    {
      column: [
        {
          title: 'component',
          component: changeLanguageComponent
        },
        {
          title: 'component',
          component: contactUsComponent
        }
      ]
    }
  ];

  return (
    <BinaModal
      isOpen={isOpenHeaderMenu}
      onRequestClose={setIsOpenHeaderMenu}
      modalId="header-menu"
      overlayClassName="modal__overlay--header-menu"
      contentClassName="modal__content--header-menu"
      animation="top"
    >
      <FlexCenterAligned
        style={{ width: `calc(100% - ${scrollbarWidth}` }}
        onMouseLeave={handleModalMenuMouseLeave}
        onMouseEnter={handleModalMenuMouseEnter}
      >
        <HeaderMenuWrapper data-cy="header-menu-columns">
          {menuListArray.map(({ column }, index) => (
            <HeaderMenuColumn key={index} data-cy="header-menu-column">
              {column.map(
                ({ title, path, component, cypress, label, route }, i) => {
                  if (title === 'component') {
                    return component;
                  }
                  const isCurrentPage = getIsCurrentPage(path, router);
                  const isUseLinkComponent =
                    CONFIG.adaptivePageRoutes.includes(route);

                  return (
                    <HeaderMenuColumnItem
                      key={`${title}_${i}`}
                      href={path}
                      selected={isCurrentPage}
                      data-cy={cypress}
                      component={isUseLinkComponent ? Link : 'a'}
                      onClick={() => setIsOpenHeaderMenu(false)}
                    >
                      {title}
                      {label && <Label>{label}</Label>}
                    </HeaderMenuColumnItem>
                  );
                }
              )}
            </HeaderMenuColumn>
          ))}
        </HeaderMenuWrapper>
      </FlexCenterAligned>
    </BinaModal>
  );
};

HeaderModalMenu.propTypes = {
  contacts: PropTypes.object,
  isOpenHeaderMenu: PropTypes.bool,
  setIsOpenHeaderMenu: PropTypes.func,
  handleModalMenuMouseLeave: PropTypes.func,
  handleModalMenuMouseEnter: PropTypes.func
};

export default HeaderModalMenu;
